import React, { forwardRef, useImperativeHandle, useEffect } from "react";
import { EditPageButton } from './../../../common/EditPage';
import './tasks.css';

const DialerContainer = forwardRef(({ onCallStateChange }, ref) => {

    // Update callback when inCall changes
    useEffect(() => {
        if (onCallStateChange) {
            onCallStateChange(inCall);
        }
    }, [inCall, onCallStateChange]);

    // Expose hangup method and inCall state to parent components
    useImperativeHandle(ref, () => ({
        doHangup: hangupCall,
        inCall
    }));

    const handleAnswer = () => {
        if (incomingCall?.jsep) {
            answerCall(incomingCall.jsep);
        }
    };

    return(
        <>
            {incomingCall && callState === 'ringing' && (
                <div className="col-12">
                    <h4 className="mt-3">Incoming call from {incomingCall.caller}</h4>
                    <div className="answer-reject-buttons">
                        <EditPageButton 
                            handleClick={handleAnswer} 
                            value="Answer"
                            icon="call"
                            bsStyle="success"
                            className="btn-telephone me-4"
                        />
                        <EditPageButton 
                            handleClick={rejectCall} 
                            value="Reject"
                            icon="call_end"
                            bsStyle="danger"
                            className="btn-telephone btn-telephone-danger"
                        />
                    </div>
                </div>
            )}
            {inCall && callState === 'connected' && (
                <div className="col-12">
                    <h4 className="mt-3">In call</h4>
                    <EditPageButton 
                        handleClick={hangupCall} 
                        value="Hangup"
                        icon="call_end"
                        bsStyle="danger"
                        className="btn-telephone btn-telephone-danger"
                    />
                </div>
            )}
        </>
    )
});

export default DialerContainer;
